import { InProgressVehicle, Vehicle } from '../interfaces/interface.vehicle';

export function isValidValue(value) {
  return !!value && value !== 'false' && value !== '0';
}

export function isAnsweredCategory(questions = [], answers = {}) {
  return questions.some((question) => {
    if (question.selectChoices?.length > 0) {
      return question.selectChoices.some((choice) => isValidValue(answers[choice.qRef].value));
    }
    const value = answers[question.questionId]?.value;
    return isValidValue(value);
  });
}

export const trackUserInteraction = (categoryQuestionsAnswers = {}) => {
  const categories = Object.keys(categoryQuestionsAnswers);
  return categories.reduce((acc, item) => {
    return { ...acc, [item]: isAnsweredCategory(categoryQuestionsAnswers[item].questions, categoryQuestionsAnswers[item].answers) };
  }, {});
};

export function mapColorNameToHex(colorName = '') {
  const map = {
    red: '#DD4343',
    burgundy: '#AB2431',
    blue: '#1261A0',
    black: '#202020',
    gray: '#A0A0A0',
    silver: 'linear-gradient(#D5D5D5, #AFAFAF)',
    brown: '#6D462A',
    green: '#006400',
    white: '#FDFDFD',
    yellow: '#FEDD37',
    gold: 'linear-gradient(#F4DF99, #E0C274)',
    pink: '#F493B4',
    beige: '#CFB48E',
    orange: '#F79F1D',
    purple: '#804F9D',
  };

  const cleanedColor = colorName.toLocaleLowerCase();
  return map[cleanedColor] ? map[cleanedColor] : '';
}

export const baseVehicleState: Vehicle = {
  drivetrainId: 0,
  drivetrain: '',
  colorId: 0,
  color: '',
  makeId: 0,
  make: '',
  engineId: 0,
  engine: '',
  modelId: 0,
  model: '',
  transmissionId: 0,
  transmission: '',
  trimId: 0,
  trim: '',
  yearId: 0,
  year: 0,
  vin: '',
  mileage: 0,
  bodyStyle: '',
};

export const defaultInProgressVehicleState: InProgressVehicle = {
  description: {
    vin: '',
    vehicle: '',
    mileage: 0,
    color: '',
    twoSetsOfKeys: '',
  },
  options: {
    engine: '',
    transmission: '',
    drive: '',
    installedOptions: [],
  },
  history: {
    originalOwner: '',
    accidents: '',
    auctionedInLast45Days: '',
    rentalVehicle: '',
  },
  replacementVehicle: {
    lookingFor: '',
    vehicle: '',
    year: '',
  },
};

export const MSM_MILEAGE_ERRORS = {
  MILEAGE_MISSING: 'Please enter your mileage.',
  INVALID_MILEAGE: "Vehicles with more than 300,000 miles aren't eligible for an ICO.",
  MIN_MILEAGE: "Vehicles with less than min miles aren't eligible for an Instant Cash Offer.",
  LESS_THAN_MIN_MILEAGE_FROM_AUTOCHECK: 'The entered mileage is less than what we have on record. Please confirm before continuing.',
  GREATE_THAN_TYPICAL_MILEAGE: 'The entered mileage is higher than expected. Please confirm before continuing.',
};

export const MIN_MILEAGE = 1;
export const MAX_MILEAGE = 300000;

export const convertOptionsToRequestString = (options: { optionId: number; isSelected: boolean }[]) => {
  let requestString = '';
  options.forEach((option) => {
    requestString += `${option.optionId}|${option.isSelected}|`;
  });
  return requestString;
};

export const filterTrueOptions = (options = []) => {
  return options.filter((options) => options.isSelected === true).map((options) => options.optionId);
};

export const filterFalseOptions = (options = []) => {
  return options.filter((options) => options.isSelected === false).map((options) => options.optionId);
};

export const combineOptions = (trueOptions: number[], falseOptions: number[]) => {
  return [...trueOptions.map((optionId) => ({ optionId, isSelected: true })), ...falseOptions.map((optionId) => ({ optionId, isSelected: false }))];
};

export const capitalizedFirstLeter = (text) => {
  const strArr = text.toLowerCase().split(' ');
  for (let i = 0; i < strArr.length; i++) {
    strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
  }
  return strArr.join(' ');
};

export const getMileageError = (errors: Set<string>, minimumMileageIneligibleThreshold: number): string => {
  const errorMessage = Object.values(MSM_MILEAGE_ERRORS).find((err) => errors.has(err));
  if (errorMessage?.includes(MSM_MILEAGE_ERRORS.MIN_MILEAGE) && minimumMileageIneligibleThreshold) {
    return `Vehicles with less than ${minimumMileageIneligibleThreshold} miles aren't eligible for an Instant Cash Offer.  Please verify the mileage you entered.`;
  }

  return errorMessage;
};

export const parseMileage = (mileage: string) => mileage.replace(/[^0-9]/g, '').replace(/^0/, '');
